var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"gst-save-amount-card-chip"},[_vm._v(" "+_vm._s(_vm.$t('_common:terms.hotelSaveAmountCard', { amount: _vm.saveAmount }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }